import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import HeroBg from "../components/HeroBg/HeroBg";
import Loader from "../components/Loader/Loader";
import Meta from "../components/Meta";

const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: yup
    .string()
    .matches(/^\d{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  message: yup.string().required("Message is required"),
});

const ContactInfo = ({ icon, title, content }) => (
  <div className="col-lg-4">
    <div className="contact-info">
      <div className="single-cta pb-30 mb-30">
        <div className="f-cta-icon">
          <i className={icon}></i>
        </div>
        <h5>{title}</h5>
        <p>{content}</p>
      </div>
    </div>
  </div>
);

// Contact Form Component
const ContactForm = ({ register, handleSubmit, errors, onSubmit }) => (
  <div className="contact-form mt-30">
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <div className="row">
        <div className="col-lg-12">
          <div className="contact-field p-relative c-name mb-30">
            <input
              type="text"
              {...register("name")}
              placeholder="Name"
              className="wpcf7-form-control"
            />
            {errors.name && (
              <span className="error">{errors.name.message}</span>
            )}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="contact-field p-relative c-subject mb-30">
            <input
              type="email"
              {...register("email")}
              placeholder="Email"
              className="wpcf7-form-control"
            />
            {errors.email && (
              <span className="error">{errors.email.message}</span>
            )}
          </div>
        </div>
        <div className="col-lg-6">
          <div className="contact-field p-relative c-subject mb-30">
            <input
              type="tel"
              {...register("phone")}
              placeholder="Phone No."
              className="wpcf7-form-control"
            />
            {errors.phone && (
              <span className="error">{errors.phone.message}</span>
            )}
          </div>
        </div>
        <div className="col-lg-12">
          <div className="contact-field p-relative c-message mb-30">
            <textarea
              {...register("message")}
              placeholder="Write Message"
              className="wpcf7-form-control"
            />
            {errors.message && (
              <span className="error">{errors.message.message}</span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "20px",
            }}
          >
            <button type="submit" className="btn-find-more">
              Send Message
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
);

// Google Map Embed Component
const MapEmbed = () => (
  <div className="col-lg-6">
    <div className="contact-info">
      <div className="single-cta pb-30 mb-30">
        <iframe
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0s1a7phLN0iaD6-UE7m4qP-z21pH0eSc&q=Kathwada, Ahmedabad, Gujarat, India"
          width="100%"
          height="450"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          title="Vitri Enterprises Location"
        ></iframe>
      </div>
    </div>
  </div>
);

const ContactUs = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(
        "https://vitri-backend.onrender.com/api/inquiries",
        data
      );
      alert(
        "Your message has been sent successfully! Thank you for reaching out. We appreciate your time and effort." ||
          response.data.message
      );
      reset();
    } catch (error) {
      console.error("Failed to send message:", error);
      alert(error.response?.data?.message || "Failed to send message.");
    }
  };

  return (
    <div>
      <Meta
        title="VITRI ENTERPRISES"
        description="Get in touch with VITRI ENTERPRISES for expert CCTV, EPABX, networking, access control, and security automation services in Gujarat. Let’s secure your space today!"
        keywords="contact VITRI ENTERPRISES, CCTV provider contact Gujarat, EPABX support, access control inquiry, boom barrier services"
        canonical="https://vitrienterprises.in/contact"
      />

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="sticky-header">
            <Header />
          </div>
          <HeroBg title={"Contact Us"} />
          <div className="pages-content">
            <section className="contact-area after-none contact-bg pt-90 pb-30 p-relative">
              <div className="container">
                <div className="row">
                  <ContactInfo
                    icon="far fa-map"
                    title="Office Address"
                    content="61, Govardhan business hub, Rd Number 5, Kathwada GIDC, Odhav Industrial Estate, Odhav, Ahmedabad, Gujarat 382430"
                  />
                  <ContactInfo
                    icon="far fa-envelope-open"
                    title="Message Us"
                    content={
                      <a href="mailto:vitrienterprises@gmail.com">
                        vitrienterprises@gmail.com
                      </a>
                    }
                  />
                  <ContactInfo
                    icon="fa fa-phone-alt"
                    title="Contact Info"
                    content={<a href="tel:+919624930796">96249 30796</a>}
                  />
                </div>
              </div>
            </section>
            <section className="contact-area pt-120 pb-120 p-relative">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="contact-bg02">
                      <div className="section-title center-align text-center">
                        <h2>Get A Quote</h2>
                      </div>
                      <ContactForm
                        register={register}
                        handleSubmit={handleSubmit}
                        errors={errors}
                        onSubmit={onSubmit}
                      />
                    </div>
                  </div>
                  <MapEmbed />
                </div>
              </div>
            </section>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
};

export default ContactUs;
